import { useCallback, useState } from "react";
import { Button } from "@radix-ui/themes";
import { Dialog } from "../../components/shared/dialog";
import styles from "./Agents.module.scss";
import { PlusIcon } from "@radix-ui/react-icons";
import { useCreateTeam } from "@/api/useTeams";
import { toast } from "sonner";

interface CreateTeamDialogProps {
  refetch: () => Promise<unknown>;
}

export default function CreateTeamDialog({ refetch }: CreateTeamDialogProps) {
  const { mutateAsync: createTeam, isLoading } = useCreateTeam();
  const [open, setOpen] = useState<boolean>(false);
  const [teamName, setTeamName] = useState<string>("");

  const closeDialog = () => {
    setOpen(false);
    setTeamName("");
  };

  const handleCreateTeam = useCallback(async () => {
    if (!teamName.trim()) return;

    try {
      await createTeam({
        name: teamName.trim(),
      });
      await refetch();
      closeDialog();
      toast(`Team "${teamName}" created successfully`);
    } catch (error) {
      try {
        // window.quack?.proactiveTrigger();
      } catch (e) {}
      toast("Failed to create team");
    }
  }, [teamName, createTeam, refetch]);

  return (
    <>
      <Button
        color="gray"
        variant="solid"
        highContrast
        onClick={() => setOpen(true)}
      >
        <PlusIcon />
        Create Team
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <Dialog.Content size="small">
          <div className={styles.AddTeam}>
            <Dialog.Close className={styles.Close} />

            <div className={styles.Header}>
              <div className={styles.Title}>Create New Team</div>
            </div>

            <div className={styles.Content}>
              <div className={styles.AccessParameter}>
                <div className={styles.Option}>
                  <div className={styles.Title}>Team Name</div>
                </div>

                <input
                  type="text"
                  className={styles.Input}
                  placeholder="Engineering Team"
                  value={teamName}
                  onChange={(e) => setTeamName(e.target.value)}
                  autoFocus
                  required
                />
              </div>
            </div>

            <div className={styles.Footer}>
              <Button
                color="gray"
                highContrast
                onClick={handleCreateTeam}
                disabled={!teamName.trim() || isLoading}
                className={styles.AddButton}
              >
                {isLoading ? "Creating..." : "Create Team"}
              </Button>
              <Button
                color="gray"
                variant="outline"
                size="2"
                highContrast
                onClick={closeDialog}
                className={styles.CancelButton}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog>
    </>
  );
}
